import React, { useEffect } from 'react';
import { Footer } from './Footer';
import { useCurrency } from '../contexts/CurrencyContext';

const handleSmoothNavigation = (hash) => {
  // Store the target hash in sessionStorage so it can be handled after navigation
  sessionStorage.setItem('scrollTarget', hash);
  // Navigate to main page
  window.location.href = '/';
};

const handleBookNow = () => {
  // Store pre-populated message for contact form
  const promoMessage = "I'm interested in your NZ$199 React & Next.js Multi-section Website Landing Page service. Please provide me with more details about this offer and how to get started.";
  sessionStorage.setItem('promoMessage', promoMessage);
  handleSmoothNavigation('#contact');
};

const Promo5Page = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    
    // Fix horizontal scrollbar on promo pages
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    
    // Center logo on mobile
    const logoContainer = document.querySelector('.promo-detail-page .row:first-child .col-md-12');
    if (logoContainer && window.innerWidth <= 768) {
      logoContainer.style.textAlign = 'center';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  return (
    <div>
      <div className="promo-detail-page">
        <div className="container" style={{padding: '30px 0'}}>
          {/* Logo */}
          <div className="row" style={{marginBottom: '30px'}}>
            <div className="col-md-12">
              <a href="/" style={{display: 'inline-block'}}>
                <img 
                  src="/img/Banner_16x_TR_Trim&ColorEdit.png" 
                  alt="Yuccan Technologies Logo" 
                  style={{height: '60px', width: 'auto'}} 
                />
              </a>
            </div>
          </div>

          {/* Hero Section - Two Column Layout */}
          <div className="row" style={{display: 'flex', alignItems: 'stretch'}}>
            {/* Left Column - Image */}
            <div className="col-xs-12 col-md-6" style={{display: 'flex', flexDirection: 'column'}}>
              <img 
                src="img/promo5.jpg" 
                alt="Promo: NZ$199 React & Next.js Multi-section Website Landing Page Build & Host" 
                className="img-responsive"
                style={{
                  width: '100%', 
                  height: 'auto', 
                  borderRadius: '10px',
                  flex: '1'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'flex';
                }}
              />
              <div style={{
                display: 'none', 
                width: '100%', 
                height: '400px', 
                backgroundColor: '#f8f9fa', 
                borderRadius: '10px', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: '#6c757d', 
                fontSize: '18px',
                flex: '1'
              }}>
                Product Image Placeholder
              </div>
            </div>

            {/* Right Column - Promo Information */}
            <div className="col-xs-12 col-md-6" style={{display: 'flex', flexDirection: 'column'}}>
              <div className="promo-content" style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <h1 style={{color: '#333', marginBottom: '10px'}}>
                  Promo: NZ$199 React & Next.js Multi-section Website Landing Page Build & Host		  
                </h1>
                
                <div className="price-section" style={{marginBottom: '0px', display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                  <span className="current-price" style={{fontSize: window.innerWidth <= 576 ? '26px' : '24px', fontWeight: 'bold', color: '#f8825a'}}>$199</span>
                  <span className="price-period" style={{fontSize: window.innerWidth <= 576 ? '22px' : '20px', textDecoration: 'line-through', color: '#999', marginLeft: '15px', marginRight: '15px'}}>$599 Typical</span>
				  <span className="current-price" style={{fontSize: window.innerWidth <= 576 ? '26px' : '24px', fontWeight: 'bold', color: '#f8825a'}}>excluding taxes</span>
                  <span className="discount-badge" style={{backgroundColor: '#28a745', color: 'white', padding: '5px 12px', borderRadius: '20px', fontSize: window.innerWidth <= 576 ? '16px' : '14px', fontWeight: 'bold', marginLeft: '15px'}}>67% OFF</span>
                </div>

                <div className="product-description" style={{marginBottom: '0px', flex: '1'}}>
                  <h3 style={{color: '#333', marginBottom: '15px'}}>Description</h3>
                  <p style={{color: '#000', lineHeight: '1.6'}}>
                    Quick turnaround for single page multi-section website landing page build, plus deployment and free hosting for the first month.
                  </p>
                </div>

                <div className="promo-actions" style={{marginTop: 'auto'}}>
                  <button onClick={handleBookNow} className="btn btn-custom btn-lg" style={{marginRight: '15px', textDecoration: 'none'}}>Book Now</button>
                  <button onClick={() => handleSmoothNavigation('#promos')} className="btn btn-custom btn-lg" style={{borderColor: '#2B4B8C', color: '#333', backgroundColor: 'transparent', textDecoration: 'none'}} onMouseEnter={(e) => {e.target.style.backgroundColor='#2B4B8C'; e.target.style.color='white';}} onMouseLeave={(e) => {e.target.style.backgroundColor='transparent'; e.target.style.color='#333';}}>Back to Promos</button>
                </div>
              </div>
            </div>
          </div>

          {/* Terms Section */}
          <div className="row" style={{marginTop: '30px'}}>
            <div className="col-md-12">
              <div className="terms-section" style={{backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '10px', border: '1px solid #dee2e6'}}>
               
                <div style={{color: '#000', lineHeight: '1.6'}}>
				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>What You Get with This Promo</h5>
                  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Professional <strong>React & Next.js</strong> landing page (single page, multi-section) of a fixed design template.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Responsive and maintainable design, <strong>optimized</strong> for tablet and mobile.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Up to <strong>six (6)</strong> sections, i.e. Hero, About Us, Services, Portfolio, etc.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Contact form with built-in <strong>validation and spam control</strong>.</p>
                  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Smooth scrolling</strong> navigation between sections.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Fast-loading, <strong>SEO-ready</strong> build.</p>
				  <p style={{marginBottom: '20px', fontSize: '14px'}}>🔹 Free deployment and first-month hosting on our shared hosting platform priced at <strong>NZ$5/month</strong> for micro web applications.</p>
				  
				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>Clarifications</h5>
                  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Our responsibility:</strong> Deliver a modern React + Next.js landing page with defined sections and working contact form, live on the internet.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Your responsibility:</strong> Register a domain name and provide your logos, brand colours, images, and text to our specifications.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 Up to <strong>two (2)</strong> revise and edit sessions of client-provided content; the fixed design template cannot be changed.</p>
                  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Timeline:</strong> Delivery within 24 hours of receiving your final edit.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Optional extras:</strong> Email hosting, SEO optimization, CMS integration, website expansion, and custom functions available separately.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>Fair terms:</strong> Payment upfront, simple refund rules, liability capped at service price.</p>
				  <p style={{marginBottom: '10px', fontSize: '14px'}}>🔹 <strong>No obligation:</strong> No ongoing subscription; one-time purchase.</p>
				  <p style={{marginBottom: '20px', fontSize: '14px'}}>🔹 <strong>Lawful use only:</strong> The landing page may not be used for illegal activities.</p>
				  
				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>Suitable for Every Industry</h5>
                  <p style={{marginBottom: '20px', fontSize: '14px'}}>🔹 We provide a high quality, warrantied landing page and hosting service for any lawful business.</p>

				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>Promotion Validity</h5>
                  <p style={{marginBottom: '20px', fontSize: '14px'}}>This promo is always valid for all new domain names; edits or swap-outs of existing landing pages do not qualify.</p>
				  
				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>Launch your Landing Page and Increase your Business Visibility</h5>
                  <p style={{marginBottom: '20px', fontSize: '14px', color: '#dc3545'}}>Read and save or print the <a href="/legal/sla-landing-page.html" target="_blank" rel="noopener noreferrer">Service Level Agreement</a> for this Promo.</p>

				  <h5 style={{color: '#333', marginBottom: '10px', fontSize: '18px'}}>Questions?</h5>
                  <p style={{marginBottom: '10px', fontSize: '14px'}}>Call us on <strong>+64 9 886 4638</strong> during business hours (9am to 5pm weekdays), or send us an email via the <button onClick={() => { sessionStorage.setItem('scrollTarget', '#contact'); window.location.href = '/'; }} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}><strong>contact form</strong></button> on our main landing page.</p> 
										
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Centered BOOK NOW button - SAME STRUCTURE AS TOP BUTTONS */}
        <div className="row" style={{marginTop: '0px', marginBottom: '30px'}}>
          <div className="col-md-12">
            <div className="promo-actions" style={{marginTop: 'auto'}}>
              <button onClick={handleBookNow} className="btn btn-custom btn-lg" style={{marginRight: '15px', textDecoration: 'none'}}>Book Now</button>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};		  

export default Promo5Page;